module.exports = __webpack_public_path__ + "static/media/logo8a.95cc80fa.png";